var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mockData as usersData } from '@web/lib/demo/data/users';
import { formatDuration, getPercentageDiff, randomInt } from '@workalizer/shared/utils';
export var invocationsByUser = function (input) {
    var demoUsers = usersData
        .filter(function (user) { return user.isActiveOnGoogle; })
        .slice(0, 10);
    var allUserIds = demoUsers.map(function (user) { return user.id; });
    var filteredUserIds = input.orgUnitId
        ? allUserIds.filter(function (userId) {
            var user = demoUsers.find(function (u) { return u.id === userId; });
            return user === null || user === void 0 ? void 0 : user.userOrgUnits.some(function (uou) { return uou.orgUnitId === input.orgUnitId; });
        })
        : allUserIds;
    var hasOrgUnit = Boolean(input.orgUnitId);
    var shouldCompareWithTeam = hasOrgUnit && filteredUserIds.length > 0;
    var items = [];
    filteredUserIds.forEach(function (userId) {
        var _a, _b, _c;
        var user = demoUsers.find(function (u) { return u.id === userId; });
        if (!user)
            return;
        var invocations = randomInt(10, 100);
        var previousInvocations = invocations + randomInt(-20, 20);
        var minutes = invocations > 0 ? randomInt(invocations * 2, invocations * 6) : 0;
        var previousMinutes = previousInvocations > 0
            ? randomInt(previousInvocations * 2, previousInvocations * 6)
            : 0;
        var teamAverageInvocations = shouldCompareWithTeam
            ? randomInt(invocations - 15, invocations + 15)
            : 0;
        var teamAverageMinutes = shouldCompareWithTeam
            ? randomInt(teamAverageInvocations * 2, teamAverageInvocations * 6)
            : 0;
        items.push(__assign(__assign({ userId: userId, userName: user.name || user.email, userEmail: user.email }, (!input.orgUnitId
            ? {
                orgUnitName: (_c = (_b = (_a = user.userOrgUnits[0]) === null || _a === void 0 ? void 0 : _a.orgUnit) === null || _b === void 0 ? void 0 : _b.title) !== null && _c !== void 0 ? _c : null
            }
            : {})), { invocations: {
                count: invocations,
                prevPeriodDiff: getPercentageDiff(Math.max(previousInvocations, 0), invocations),
                teamAvgDiff: shouldCompareWithTeam
                    ? getPercentageDiff(teamAverageInvocations, invocations)
                    : null
            }, timeSpent: {
                formatted: formatDuration(minutes / 60),
                prevPeriodDiff: getPercentageDiff(Math.max(previousMinutes, 0), minutes),
                teamAvgDiff: shouldCompareWithTeam
                    ? getPercentageDiff(teamAverageMinutes, minutes)
                    : null
            } }));
    });
    var sortedItems = items.sort(function (a, b) { return b.invocations.count - a.invocations.count; });
    return {
        items: sortedItems,
        total: sortedItems.length
    };
};
